import React from "react";

const JOURNEY_ITEMS = [
  {
    year: "2019",
    title: "Data Analytics – City National Bank",
    description:
      "Set up the Oracle BDA cluster and designed, built, deployed, and maintained end-to-end data pipelines on the Enterprise Data Lake.",
  },
  {
    year: "2020",
    title: "Coding for Kids – Community Impact",
    description:
      "Successfully conducted online 'Coding for Kids' classes during COVID, expanding into education and community impact.",
  },
  {
    year: "2021",
    title: "Data Analytics – Kafka & Confluent Platform",
    description:
      "Deployed a secure Kafka Confluent Platform 7.1 cluster using Ansible automation and delivered data engineering solutions.",
  },
  {
    year: "2022",
    title: "Data Analytics – CDH → CDP Upgrade with Cloudera",
    description:
      "Partnered with Cloudera to upgrade the platform from CDH 5.14.4 to CDP 7.1.7, improving data access for data science and engineering teams.",
  },
  {
    year: "2023",
    title: "Data Analytics – Streaming Pipelines",
    description:
      "Implemented Kafka and Spark Streaming pipelines integrating S3, Spark, Kafka, and Solace source/sink connectors.",
  },

  /* ✅ 2024 – ALL IN ONE BOX */
  // {
  //   year: "2024",
  //   title: "Web Development",
  //   description: (
  //     <>
  //       <p>
  //         <strong>React Web Application</strong>
  //         <br />
  //         Developed a React-based web application implementing secure OpenAI
  //         integrations with Single Sign-On (SSO).
  //       </p>
  //       <p>
  //         <strong>Flask Web Application</strong>
  //         <br />
  //         Built a Flask-based web application with Open AIs (Python, Flask,
  //         MySQL), using tools such as Notion, Promod, and World Time.
  //       </p>
  //       <p>
  //         <strong> Multi-vendor Digital Solutions</strong>
  //         <br />
  //         Delivered multi-vendor digital solutions including WhatsApp Store, API
  //         integrations, e-commerce platforms, and social media setup.
  //       </p>
  //     </>
  //   ),
  // },
  {
    year: "2024",
    title: "AI-Powered WhatsApp Agents",
    description: (
      <>
        <p>
          <strong>Food Ordering</strong> <br />
          Let customers place food orders through WhatsApp using text or voice.
        </p>
        <p>
          <strong>Appointment Booking</strong>
          <br /> Allow customers to book services, dates, and time slots
          directly on WhatsApp.
        </p>
        <p>
          <strong>Chatbot</strong> <br />
          Answer customer enquiries through WhatsApp using an AI-powered chatbot
          for faster support.
        </p>

        <p>
          <strong>Grocery Ordering</strong>
          <br /> Enable customers to order groceries through WhatsApp using
          items, quantities, lists, or images.
        </p>
      </>
    ),
  },
  /* ✅ 2025 – BOX 3 (Cloudera Labs + E-Learning combined) */
  {
    year: "2025",
    title: "Data Analytics – Cloudera Labs & E-Learning",
    description: (
      <>
        <p>
          Set up AWS-based Cloudera clusters and labs: Admin, Data Engineering,
          Data Analyst, CAI, and CML.
        </p>
        <p>
          Created an e-learning platform for the above Cloudera labs and
          content.
        </p>
      </>
    ),
  },
  {
    year: "",
    title: "RPA Consultant",
    description: (
      <>
        <p>
          <strong>Accounts RPA</strong>
          <br />
          Implemented Accounts RPAs covering ERP login automation,
          Ready-to-Payout processing, automated email sharing, and disbursement
          workflows integrated with ERP.
        </p>
        <p>
          Streamlined accounts operations by automating course validation,
          disbursement validation, and credit note validation workflows.
        </p>
        <p>
          <strong>HR RPA</strong>
          <br />
          Automated HR workflows including trainers’ fee calculation, attendance
          report generation, and TRAQOM survey report processing.
        </p>
      </>
    ),
  },
  {
    year: "2026",
    title: "AI-Powered WhatsApp for Enterprise",
    description: (
      <>
        <p>
          <strong>Accounting</strong> <br />
          Capture invoices and receipts through WhatsApp for automated
          accounting workflows.
        </p>
        <p>
          <strong>Attendance Tracking</strong> <br />
          Track worker attendance through WhatsApp image submission with reports
          and dashboard monitoring.
        </p>
        <p>
          <strong>SOR Search</strong>
          <br /> Search Schedule of Rates information instantly through a
          WhatsApp-based AI assistant.
        </p>
        {/* <p>
          <strong>Invoice Data Capture</strong>
          <br /> Extract invoice details from WhatsApp-submitted documents for
          accounting and reporting.
        </p> */}
        <p>
          <strong>Image Data Extract</strong>
          <br /> Extract structured data from images, forms, receipts, and
          documents shared on WhatsApp.
        </p>
      </>
    ),
  },

  /* ✅ 2025 – BOX 1 */
  // {
  //   year: "2025",
  //   title: "Digital Consultant – Content",
  //   description:
  //     "Produced 100+ social media videos to build brand awareness and education.",
  // },

  /* ✅ 2025 – BOX 2 (Accounts + HR combined) */
  // {
  //   year: "",
  //   title: "RPA Consultant – Accounts & HR",
  //   description: (
  //     <>
  //       <p>
  //         <strong>Accounts RPA:</strong> Course Validation, Disburse Validation,
  //         Credit Note Validation.
  //       </p>
  //       <p>
  //         <strong>HR RPA:</strong> Trainers’ Fee Calculation, Attendance Report,
  //         TRAQOM Survey Report.
  //       </p>
  //     </>
  //   ),
  // },
];


export default function JourneyTimeline() {
  return (
    <section className="timeline">
      <h2 className="timeline-heading">SiW Journey (2019–2025)</h2>
      <div className="timeline-list">
        {JOURNEY_ITEMS.map((item, index) => (
          <article className="timeline-item" key={`${item.year}-${index}`}>
            <div className="timeline-left">
              <span className="timeline-year" >{item.year}</span>
              <span className="timeline-dot" />
              {/* {index !== JOURNEY_ITEMS.length - 1 && ( */}
                <span className="timeline-line" />
              {/* })}*/}
            </div>
            <div className="timeline-card">
              <h3 className="timeline-title">{item.title}</h3>
              <p className="timeline-description">{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
